/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "./utils";
import { Icon } from "@aws-amplify/ui-react";
export default function Thumbsdown(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    { overrides: { Thumbsdown: {} }, variantValues: { property1: "Default" } },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Icon
      width="56px"
      height="56px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      viewBox={{ minX: 0, minY: 0, width: 56, height: 56 }}
      paths={[
        {
          d: "M19.383 0.000999928L16.125 0.000999928C13.195 0.000999928 10.688 0.165 9 0.587C5.766 1.384 3.75 3.634 3.75 6.493C3.75 7.103 3.844 7.642 4.008 8.181C2.391 9.375 1.477 11.157 1.477 13.125C1.477 14.062 1.664 15 2.016 15.797C0.938 16.898 0.282 18.516 0.282 20.203C0.282 21.328 0.562 22.476 1.055 23.343C0.375 24.281 0 25.593 0 27C0 30.516 2.72 33.281 6.211 33.281L15.071 33.281C15.657 33.281 16.008 33.516 16.008 34.008C16.008 36.562 12.024 42.492 12.024 47.25C12.024 50.484 14.274 52.828 17.391 52.828C19.711 52.828 21.235 51.633 22.758 48.726C25.618 43.242 28.993 38.391 34.571 31.594L39.024 31.594C44.813 31.594 49.454 25.054 49.454 17.039C49.454 9.164 44.344 2.602 38.134 2.602L30.399 2.602C27.305 0.984 23.555 0.000999928 19.383 0.000999928ZM16.102 3.539L19.36 3.562C29.18 3.656 35.836 9.211 35.836 17.18C35.836 22.242 34.711 25.477 31.524 29.742C27.984 34.453 23.11 40.102 19.594 47.109C18.657 48.961 18.164 49.289 17.391 49.289C16.242 49.289 15.563 48.562 15.563 47.25C15.563 43.43 19.547 37.687 19.547 34.008C19.547 31.359 17.344 29.742 14.555 29.742L6.211 29.742C4.664 29.742 3.539 28.57 3.539 27C3.539 25.898 3.891 25.172 4.805 24.281C5.063 24.047 5.157 23.812 5.157 23.555C5.157 23.344 5.087 23.156 4.922 22.945C4.149 21.844 3.821 21.117 3.821 20.203C3.821 19.101 4.36 18.141 5.414 17.343C5.884 17.016 6.118 16.641 6.118 16.243C6.11197 16.0769 6.06342 15.915 5.977 15.773C5.297 14.484 5.016 13.969 5.016 13.125C5.016 11.859 5.813 10.898 7.5 10.031C7.852 9.844 8.063 9.562 8.063 9.211C8.063 9.071 8.016 8.93 7.946 8.766C7.36 7.336 7.289 7.101 7.289 6.492C7.289 5.344 8.133 4.453 9.844 4.032C11.227 3.656 13.43 3.516 16.102 3.539ZM38.133 6.141C42.282 6.141 45.915 11.109 45.915 17.039C45.915 23.109 42.657 28.055 39.024 28.055L36.867 28.055C38.624 24.75 39.374 21.328 39.374 17.25C39.374 12.844 37.781 9.023 34.968 6.14L38.133 6.141Z",
          fill: "rgba(204,164,59,1)",
          fillRule: "nonzero",
          style: { transform: "translate(5.85%, 2.83%)" },
        },
      ]}
      {...getOverrideProps(overrides, "Thumbsdown")}
      {...rest}
    ></Icon>
  );
}
